import {Component, ComponentFactoryResolver, ComponentRef, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


declare let moment: any;

@Component({
   selector: 'app-doc-type',
   template: ``,
   styles: [`
      .label-doctype {
         color: #777;
         display: block;
         font-size: 13px;
         font-weight: 400;
         margin: 15px 0 0;
         padding-bottom: 3px;
      }

      input, textarea, select {
         background: transparent;
         border: 1px solid #e5e5e5;
         border-radius: 2px;
         display: block;
         font-size: 13px;
         outline: none;
         padding: 4px;
         resize: none;
         width: 100%;
      }

      mat-select {
         width: 100%
      }

      .mandatory {
         color: #ef5350;
      }

      input[required], select[required] {
         border-color: rgba(0, 178, 201, .5);
      }

      .constraints {
         color: #999;
         font-size: 12px;
         font-style: italic;
      }
   `],
   encapsulation: ViewEncapsulation.None
})
export class DocTypeComponent {

   pleaseSelectTxt: string;
   constructor(private translate: TranslateService) {
      this.translate.get('preview.options').subscribe(s => {
         this.pleaseSelectTxt = s;
      });
   }

   static create(resolver: ComponentFactoryResolver, componentRef: ComponentRef<{}>,
                 viewContainerRef: ViewContainerRef, fields: any[]): ComponentRef<{}> {
      const factory = resolver.resolveComponentFactory(DocTypeComponent);
      let component;
      if (viewContainerRef) {
         viewContainerRef.clear();
         if (componentRef) {
            componentRef.destroy();
         }
         component = viewContainerRef.createComponent(factory);
         (<DocTypeComponent>component.instance).init(viewContainerRef, fields);
      }
      return component;
   }

   init(viewContainerRef: ViewContainerRef, fields: any[]): void {
      const container: Element = viewContainerRef.element.nativeElement;
      container.innerHTML = '';
      for (const f of fields) {
         this.createLabel(container, f);
         this.createInput(container, f);
         this.createConstraint(container, f);
      }
   }

   private createLabel(container: any, f: any): void {
      if (f.mandatory) {
         container.insertAdjacentHTML('beforeend', '<label class="label-doctype">' + f.label + ' <span class="mandatory">*</span></label>');
      } else {
         container.insertAdjacentHTML('beforeend', '<label class="label-doctype">' + f.label + '</label>');
      }
   }

   private createInput(container: any, f: any): void {
      let template: string;
      const id = f.name.replace(':', '_');
      if (f.type === 'int' || f.type === 'long') {
         template = '<input id="' + id + '" type="number" value="' + (f.value || f.defaultValue || '') + '"';
      } else if (f.type === 'float') {
         template = '<input id="' + id + '" type="number" step=".01" value="' + (f.value || f.defaultValue || '') + '"';
      } else if (f.type === 'double') {
         template = '<input id="' + id + '" type="number" step=".0001" value="' + (f.value || f.defaultValue || '') + '"';
      } else if (f.type === 'date') {
         template = '<input id="' + id + '" type="date" onkeydown="return false" value="' + (f.value || f.defaultValue || '') + '"';
      } else if (f.type === 'datetime') {
         template = '<input id="' + id + '" type="datetime-local" value="' +
            moment(f.value || f.defaultValue || '').format('YYYY-MM-DDTHH:mm') + '"';
      } else {
         if (f.listValue) {
            template = '<select id="' + id + '"';
            if (f.mandatory) {
               template += ' required';
            }
            template += '>';
            const value = f.value || f.defaultValue || '';
            if (value === '' && !f.mandatory) {
               template += '<option selected value="">' + this.pleaseSelectTxt + '</option>';
               for (const o of f.listValue) {
                  template += '<option>' + o + '</option>';
               }
            } else {
               if (value === '') {
                  template += '<option selected value="">' + this.pleaseSelectTxt + '</option>';
               } else {
                  template += '<option value="">' + this.pleaseSelectTxt + '</option>';
               }
               for (const o of f.listValue) {
                  if (value === o) {
                     template += '<option selected>' + o + '</option>';
                  } else {
                     template += '<option>' + o + '</option>';
                  }
               }
            }
            container.insertAdjacentHTML('beforeend', template + '</select>');
            return;
         }
         template = '<input id="' + id + '" type="text" value="' + (f.value || f.defaultValue || '') + '"';
      }

      if (f.mandatory) {
         template += ' required';
      }
      if (f.constraints) {
         if (f.constraints.minLength) {
            template += ' minlength="' + f.constraints.minLength + '"';
         }
         if (f.constraints.maxLength) {
            template += ' maxlength="' + f.constraints.maxLength + '"';
         }
         if (f.constraints.minValue !== undefined) {
            template += ' min="' + f.constraints.minValue + '"';
         }
         if (f.constraints.maxValue !== undefined) {
            template += ' max="' + f.constraints.maxValue + '"';
         }
         if (f.constraints.expression) {
            template += ' pattern="' + f.constraints.expression + '"';
         }
      }
      container.insertAdjacentHTML('beforeend', template + ' />');
   }

   private createConstraint(container: any, f: any): void {
      if (!f.constraints) {
         return;
      }

      const constraints = [];
      if (f.constraints.minLength) {
         constraints.push('<span class="constraints">value must be between ' + f.constraints.minLength
            + ' and ' + f.constraints.maxLength + ' characters</span>');
      } else if (f.constraints.maxLength) {
         constraints.push('<span class="constraints">maximum ' + f.constraints.maxLength + ' characters</span>');
      }
      if (f.constraints.minValue !== undefined) {
         constraints.push('<span class="constraints">value must be between ' + f.constraints.minValue
            + ' and ' + f.constraints.maxValue + '</span>');
      }
      if (f.constraints.expression) {
         constraints.push('<span class="constraints">value must match the pattern</span>');
      }
      if (constraints.length) {
         container.insertAdjacentHTML('beforeend', constraints.join(', '));
      }
   }
}
